/* cw-gallery-owner — the gallery page's owner tools: edit a tile's category
   and caption, rename a category everywhere, remove a tile, and upload new
   media. Extracted from sections/cw-gallery-page.liquid because that section
   hit Shopify's 256KB template limit; it contains no Liquid, so it moves as
   is. Reads window.__cwGalleryRows, which the section still renders. */
/* ─────────────────────────────────────────────────────────────
   Owner tools — edit or remove a tile's category.

   Unlock: add ?edit=1 and enter the gallery password. The prompt is a
   convenience gate, NOT security: everything here runs in the visitor's
   browser. The actual write is authorised by the worker behind
   `data-save-endpoint`, which checks X-Save-Secret server-side.

   No endpoint configured yet, so Apply falls back to a copy-ready JSON plus
   a link to the metafield editor — the same fallback the gallery manager uses.
   ───────────────────────────────────────────────────────────── */
(function () {
  var params = new URLSearchParams(location.search);
  var UNLOCK_KEY = 'cw-gal-edit-on';
  /* Safari in private mode throws on sessionStorage access; an unguarded read
     killed this whole script, which is why no pencils appeared there. */
  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); }
    catch (e) { return window['__' + k] === undefined ? null : (v === undefined ? window['__' + k] : (window['__' + k] = v)); }
  }
  /* ?edit=1 alone is not enough: the unlock flag is only set after the
     button has verified the password, so a bookmarked URL cannot skip it. */
  var wants = (params.get('edit') === '1' || location.hash === '#edit') && ss('cw-gal-edit-on') === '1';
  /* The site-wide flag from the admin page's "Edit the website" button opens the
     gallery tools too, so one button covers page media and the gallery. */
  if (window.cwAdminGate && window.cwAdminGate.isEditing()) wants = true;
  /* The on-page "Edit gallery" button was removed on 2026-08-17 — edit mode is
     the single switch on the admin Keys tab. Nothing to un-hide here any more. */
  /* once unlocked, stay unlocked for this tab so a normal click-through
     back to /pages/gallery keeps the tools visible */
  if (!wants && ss(UNLOCK_KEY) !== '1') return;
  ss(UNLOCK_KEY, '1');
  var PW_KEY = 'cw-gal-save-pw';
  /* The admin UI stores the same password under cw-admin-pass; reuse it so the
     owner is not asked twice. */
  var pw = ss(PW_KEY) || (function () { try { return localStorage.getItem('cw-admin-pass'); } catch (e) { return null; } })();
  document.body.classList.add('cw-gal-admin');

  var PROXY = 'https://cyclewash-admin-proxy.vvlars.workers.dev/rest/graphql.json';
  var MF_URL = 'https://admin.shopify.com/store/cyclewash/settings/custom_data/shop/metafields';
  var PENCIL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>';
  var pending = {};   /* file -> {cat: '...'} or {remove: true} */

  var chips = [].slice.call(document.querySelectorAll('.g-chip'))
    .map(function (c) { return c.getAttribute('data-filter'); })
    .filter(function (f) { return f && f !== 'all'; });


  /* Check the password for real against the proxy. A stored value is only
     trusted once it has verified in this session — otherwise a stale entry
     (e.g. from an earlier build) would fail silently and look like "it never
     asked me". On a 401 we clear it and prompt, rather than giving up. */
  function verify(candidate) {
    return fetch(PROXY, {
      method: 'POST',
      headers: {'content-type': 'application/json', 'X-CW-Admin-Pass': candidate},
      body: JSON.stringify({query: '{ shop { name } }'})
    }).then(function (r) {
      if (r.ok) return true;
      if (r.status === 401 || r.status === 403) return false;
      throw new Error('proxy HTTP ' + r.status);
    });
  }
  function ensureAuth() {
    if (ensureAuth._ok) return Promise.resolve(true);
    /* Masked dialog, stored password and re-check all live in cw-admin-gate.js,
       shared with the page editor — window.prompt showed the password in clear
       text, and each editor asking separately meant two rounds for one session. */
    return window.cwAdminGate.getPass('Edit the gallery').then(function (v) {
      if (!v) return false;
      pw = v; ensureAuth._ok = true;
      ss(PW_KEY, v);
      return true;
    }).catch(function (e) { alert('Could not reach the admin proxy: ' + e.message); return false; });
  }

  function fileOf(fig) {
    var m = fig.querySelector('.g-media');
    var u = m && (m.getAttribute('data-full') || m.getAttribute('data-src'));
    if (!u) { var im = fig.querySelector('img'); u = im && (im.currentSrc || im.src); }
    return u ? u.split('?')[0].split('/').pop() : null;
  }

  function addPencils() {
    document.querySelectorAll('.g-item:not([data-edit])').forEach(function (fig) {
      fig.setAttribute('data-edit', '1');
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'g-edit'; b.setAttribute('aria-label', 'Edit category');
      b.innerHTML = PENCIL;
      fig.appendChild(b);
    });
  }
  addPencils();
  var grid = document.getElementById('gGrid');
  if (grid && window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return; queued = true;
      requestAnimationFrame(function () { queued = false; addPencils(); });
    }).observe(grid, {childList: true});
  }
  [600, 2500].forEach(function (t) { setTimeout(addPencils, t); });

  var ov = document.createElement('div');
  ov.className = 'cw-gedit';
  ov.innerHTML =
    '<div class="cw-gedit__box">' +
      '<h3>Edit tile</h3><p class="cw-gedit__file" id="cwGeFile"></p>' +
      '<select id="cwGeSel"></select>' +
      '<input id="cwGeNew" placeholder="…or type categories (space-separated for more than one)">' +
      '<input id="cwGeCap" placeholder="Caption (leave blank to use the category name)">' +
      '<input id="cwGeAlso" placeholder="Also show under (optional) — a second category, once">' +
      '<button class="cw-gedit__ren" id="cwGeRen" type="button">Rename this category everywhere</button>' +
      '<div class="cw-gedit__row">' +
        '<button class="cw-gedit__save" id="cwGeSave">Save</button>' +
        '<button class="cw-gedit__del" id="cwGeDel">Remove image</button>' +
        '<button class="cw-gedit__cancel" id="cwGeCancel">Cancel</button>' +
      '</div>' +
      '<p class="cw-gedit__note">&ldquo;Also show under&rdquo; puts this picture in a second category without a duplicate in <em>All</em>. Changes queue up here and are applied together — nothing is written until you press Apply.</p>' +
    '</div>';
  document.body.appendChild(ov);

  var bar = document.createElement('div');
  bar.className = 'cw-gpend';
  bar.innerHTML = '<span id="cwGpText"></span><button id="cwGpApply">Apply</button><button id="cwGpClear" style="background:rgba(255,255,255,.1);color:inherit">Discard</button>';
  document.body.appendChild(bar);

  var current = null;
  function openFor(fig) {
    current = fig;
    var f = fileOf(fig);
    document.getElementById('cwGeFile').textContent = f || '(unknown file)';
    var sel = document.getElementById('cwGeSel');
    var all = (fig.getAttribute('data-cat') || '').trim();
    var cat = all.split(' ')[0];
    sel.innerHTML = chips.map(function (c) {
      return '<option value="' + c + '"' + (c === cat ? ' selected' : '') + '>' + c + '</option>';
    }).join('');
    /* A tile filed under several categories would lose the rest to the
       single-value picker, so seed the free-text field with the full set. */
    document.getElementById('cwGeNew').value = all.indexOf(' ') === -1 ? '' : all;
    var capNow = (fig.querySelector('.g-cap') || {}).textContent || '';
    capNow = capNow.trim();
    document.getElementById('cwGeAlso').value = '';
    document.getElementById('cwGeCap').value =
      capNow.toLowerCase() === cat.replace(/-/g, ' ') ? '' : capNow;
    ov.classList.add('open');
  }
  function refreshBar() {
    var n = Object.keys(pending).length + Object.keys(renames || {}).length + (adds || []).length;
    bar.classList.toggle('has', n > 0);
    document.getElementById('cwGpText').textContent = n + (n === 1 ? ' change pending' : ' changes pending');
  }
  function close() { ov.classList.remove('open'); current = null; }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.g-edit');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var fig = b.closest('.g-item');
    ensureAuth().then(function (ok) { if (ok) openFor(fig); });
  }, true);

  document.getElementById('cwGeRen').addEventListener('click', function () {
    var sel = document.getElementById('cwGeSel');
    var oldName = sel.value;
    if (!oldName) return;
    var next = slugify(window.prompt('Rename "' + oldName + '" everywhere to:', oldName) || '');
    if (!next || next === oldName) return;
    renameCategory(oldName, next);
    /* reflect the new name in the picker without reopening */
    [].forEach.call(sel.options, function (o) { if (o.value === oldName) { o.value = next; o.textContent = next; } });
    sel.value = next;
  });
  document.getElementById('cwGeCancel').addEventListener('click', close);
  ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
  document.getElementById('cwGeSave').addEventListener('click', function () {
    if (!current) return;
    var typed = slugCats(document.getElementById('cwGeNew').value);
    var cat = typed || document.getElementById('cwGeSel').value;
    var capText = document.getElementById('cwGeCap').value.trim();
    var f = fileOf(current);
    if (!f || !cat) return close();
    pending[f] = {cat: cat, cap: capText || null};

    /* A cross-listing is a second row for the same picture, flagged x:1 so the
       grid shows it under that category but not a second time in "All". One row
       per file per category — asking twice must not create a duplicate. */
    var alsoCat = slugCats(document.getElementById('cwGeAlso').value).split(' ')[0];
    if (alsoCat && alsoCat !== cat.split(' ')[0]) {
      var row = (window.__cwGalleryRows || []).filter(function (r) {
        return String(r.a).split('/').pop() === f;
      })[0];
      if (!row) {
        alert('Could not find this picture in the gallery data — cross-listing skipped.');
      } else {
        var already = (window.__cwGalleryRows || []).some(function (r) {
          return String(r.a).split('/').pop() === f && String(r.c).split(' ')[0] === alsoCat;
        }) || adds.some(function (r) {
          return String(r.a).split('/').pop() === f && r.c === alsoCat;
        });
        if (already) {
          alert('That picture is already listed under "' + alsoCat + '".');
        } else {
          var extra = {c: alsoCat, a: row.a, p: capText || row.p || alsoCat.replace(/-/g, ' '), x: 1};
          if (row.v) { extra.v = 1; if (row.po) extra.po = row.po; }
          adds.push(extra);
          if (chips.indexOf(alsoCat) === -1) chips.push(alsoCat);
        }
      }
    }
    current.setAttribute('data-cat', cat);
    var cap = current.querySelector('.g-cap');
    if (cap) cap.textContent = capText || cat.split(' ')[0].replace(/-/g, ' ');
    refreshBar(); close();
  });
  document.getElementById('cwGeDel').addEventListener('click', function () {
    if (!current) return;
    var f = fileOf(current);
    if (!f) return close();
    pending[f] = {remove: true};
    current.style.opacity = '.35';
    refreshBar(); close();
  });
  document.getElementById('cwGpClear').addEventListener('click', function () {
    pending = {}; renames = {}; refreshBar(); location.reload();
  });

  document.getElementById('cwGpApply').addEventListener('click', function () {
    var rows = (window.__cwGalleryRows || []).slice();
    if (!rows.length && !adds.length) {
      alert('Could not read the gallery rows on this page — apply from /pages/gallery-manager instead.');
      return;
    }
    var out = [];
    rows.forEach(function (r) {
      var p = pending[String(r.a).split('/').pop()];
      if (p && p.remove) return;
      if (p && p.cat) {
        r = Object.assign({}, r, {c: p.cat, p: p.cap || captionFor(r, p.cat)});
      } else if (p && p.cap) {
        r = Object.assign({}, r, {p: p.cap});
      } else if (renames[r.c]) {
        r = Object.assign({}, r, {c: renames[r.c], p: captionFor(r, renames[r.c])});
      }
      out.push(r);
    });
    /* Uploaded tiles are appended last so an existing row is never displaced
       by one; the grid sorts videos to the front on render anyway. */
    if (adds.length) out = out.concat(adds);
    /* Direct save through the admin proxy that already fronts this shop's
       Admin API (same worker the ERP/kanban and deal simulator use). It
       checks X-CW-Admin-Pass server-side, so the token never reaches the
       browser. No new infrastructure needed. */
    var btn = document.getElementById('cwGpApply');
    var label = btn.textContent;
    btn.textContent = 'Saving…'; btn.disabled = true;
    fetch(PROXY, {
      method: 'POST',
      headers: {'content-type': 'application/json', 'X-CW-Admin-Pass': pw},
      body: JSON.stringify({
        query: 'mutation($v:String!){ metafieldsSet(metafields:[{ownerId:"gid://shopify/Shop/27217166471",namespace:"custom",key:"gallery_data",type:"json",value:$v}]){ userErrors{message} } }',
        variables: {v: JSON.stringify(out)}
      })
    })
      .then(function (r) {
        if (r.status === 401 || r.status === 403) { throw new Error('auth'); }
        return r.json();
      })
      .then(function (d) {
        var errs = (((d.data || {}).metafieldsSet || {}).userErrors) || d.errors || [];
        btn.textContent = label; btn.disabled = false;
        if (errs.length) { alert('Shopify refused the write: ' + (errs[0].message || 'unknown')); return; }
        pending = {}; renames = {}; refreshBar();
        alert('Saved — ' + out.length + ' rows written. Live in a few minutes.');
      })
      .catch(function (e) {
        btn.textContent = label; btn.disabled = false;
        if (String(e.message) === 'auth') {
          try { sessionStorage.removeItem(PW_KEY); } catch (e) {}
          alert('Wrong admin password — reload and try again.');
          return;
        }
        /* network or worker failure: fall back to the manual paste */
        navigator.clipboard && navigator.clipboard.writeText(JSON.stringify(out));
        alert('Direct save failed (' + e.message + ').\n' + out.length + ' rows copied — paste into:\n' + MF_URL);
        window.open(MF_URL, '_blank', 'noopener');
      });
    return;
    /* No worker configured: hand over copy-ready JSON, same fallback as the manager */
    var blob = JSON.stringify(out);
    navigator.clipboard && navigator.clipboard.writeText(blob);
    alert(out.length + ' rows copied to the clipboard.\n\nPaste into custom.gallery_data:\n' + MF_URL);
    window.open(MF_URL, '_blank', 'noopener');
  });


  /* Renames are queued like tile edits — nothing is written until Apply. */
  var renames = {};
  function slugify(v) {
    return String(v || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  /* A row may sit in several categories at once: the filter matches on tokens,
     so "up-close pro" shows under both chips without duplicating the tile. */
  function slugCats(v) {
    var s = String(v || '').trim().toLowerCase();
    /* Commas win when present, so "Up Close, Pro" is two categories rather
       than three — space alone cannot tell a separator from a word break. */
    return s.split(s.indexOf(',') === -1 ? /\s+/ : /\s*,\s*/)
      .map(function (t) { return t.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); })
      .filter(Boolean).join(' ');
  }
  /* Re-deriving the caption from the category is right for the rows that never
     had a real one — it must not silently eat a caption somebody wrote. */
  function captionFor(row, nextCat) {
    var wasDefault = !row.p ||
      String(row.p).trim().toLowerCase() === String(row.c).split(' ')[0].replace(/-/g, ' ');
    return wasDefault ? nextCat.split(' ')[0].replace(/-/g, ' ') : row.p;
  }
  function renameCategory(oldName, next) {
    if (!next || next === oldName) return;
    renames[oldName] = next;
    document.querySelectorAll('.g-item').forEach(function (f) {
      if ((f.getAttribute('data-cat') || '').split(' ')[0] !== oldName) return;
      f.setAttribute('data-cat', next);
      var cap = f.querySelector('.g-cap');
      if (cap && cap.textContent.trim().toLowerCase() === oldName.replace(/-/g, ' ')) {
        cap.textContent = next.replace(/-/g, ' ');
      }
    });
    var chip = document.querySelector('.g-chip[data-filter="' + oldName + '"]');
    if (chip) {
      chip.setAttribute('data-filter', next);
      chip.childNodes[0].nodeValue = next.replace(/-/g, ' ').replace(/\b\w/g, function (m) { return m.toUpperCase(); }) + ' ';
    }
    if (chips.indexOf(next) === -1) chips.push(next);
    refreshBar();
  }

  /* ── Add media ─────────────────────────────────────────────────────────
     Upload an image or an mp4 from the browser and file it under a category.
     Shopify's Files API is a three-step dance: ask for a staged target, POST
     the bytes to Google's bucket, then tell Shopify the upload landed. Steps
     1 and 3 go through the same proxy as every other write here, so no API
     token is ever in the page.

     Videos get a poster frame grabbed off a <canvas> before upload — a
     poster-less <video> tile is exactly what froze Safari on this page.
     ────────────────────────────────────────────────────────────────────── */
  var adds = [];
  /* Both caps are the worker's, which decodes the base64 body in memory. */
  var MAX_IMG = 20 * 1024 * 1024;
  var MAX_VID = 40 * 1024 * 1024;
  var UPLOAD = PROXY.replace('/rest/graphql.json', '/file-upload');
  var PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';

  function gql(query, variables) {
    return fetch(PROXY, {
      method: 'POST',
      headers: {'content-type': 'application/json', 'X-CW-Admin-Pass': pw},
      body: JSON.stringify({query: query, variables: variables || {}})
    }).then(function (r) {
      if (r.status === 401 || r.status === 403) throw new Error('auth');
      if (!r.ok) throw new Error('proxy HTTP ' + r.status);
      return r.json();
    }).then(function (d) {
      if (d.errors && d.errors.length) throw new Error(d.errors[0].message);
      return d.data;
    });
  }

  /* The upload runs inside the worker, not here. The browser cannot POST to
     Shopify's staged target itself: shopify-staged-uploads.storage.googleapis.com
     sends no CORS headers for this origin, so the request dies as an opaque
     "Failed to fetch". The worker's /file-upload does all three legs
     (stagedUploadsCreate -> storage POST -> fileCreate -> poll) and returns the
     finished CDN URL. See workers/cyclewash-admin-proxy/README.md.

     Images go up as IMAGE, mp4s as FILE — a Shopify VIDEO would be transcoded
     to HLS sources the gallery rows cannot use. */
  function uploadViaWorker(blob, name, isVid) {
    return blobToB64(blob).then(function (b64) {
      return fetch(UPLOAD, {
        method: 'POST',
        headers: {'content-type': 'application/json', 'X-CW-Admin-Pass': pw},
        body: JSON.stringify({
          filename: name,
          mimeType: blob.type || (isVid ? 'video/mp4' : 'application/octet-stream'),
          contentType: isVid ? 'FILE' : 'IMAGE',
          data: b64
        })
      }).then(function (r) {
        if (r.status === 401 || r.status === 403) throw new Error('auth');
        return r.json().catch(function () { throw new Error('worker HTTP ' + r.status); });
      }).then(function (d) {
        if (d && d.ok && d.url) return d.url.split('?')[0];
        var e = (d && (d.error || (d.errors && d.errors[0] && d.errors[0].message))) || 'upload failed';
        if (/over \d+MB/.test(e)) e = e + ' — put it in Shopify Files by hand instead';
        /* A worker build that predates video support ignores contentType and
           creates every upload as an image, so an mp4 comes back as a Shopify
           processing error rather than anything clearer. */
        else if (isVid) e = e + ' (video needs the updated admin proxy)';
        throw new Error(e);
      });
    });
  }

  function blobToB64(blob) {
    return new Promise(function (resolve, reject) {
      var fr = new FileReader();
      fr.onload = function () {
        var s = String(fr.result);
        resolve(s.slice(s.indexOf(',') + 1));
      };
      fr.onerror = function () { reject(new Error('could not read the file')); };
      fr.readAsDataURL(blob);
    });
  }

  function posterOf(file) {
    return new Promise(function (resolve, reject) {
      var v = document.createElement('video');
      var url = URL.createObjectURL(file);
      var done = false;
      function fail(m) { if (!done) { done = true; URL.revokeObjectURL(url); reject(new Error(m)); } }
      v.muted = true; v.playsInline = true; v.preload = 'auto'; v.src = url;
      v.addEventListener('loadeddata', function () {
        try { v.currentTime = Math.min(1.5, (v.duration || 3) / 3); } catch (e) { fail('cannot seek'); }
      });
      v.addEventListener('seeked', function () {
        if (done) return;
        var c = document.createElement('canvas');
        c.width = v.videoWidth || 720; c.height = v.videoHeight || 720;
        try { c.getContext('2d').drawImage(v, 0, 0, c.width, c.height); }
        catch (e) { return fail('frame not readable'); }
        /* jpeg, not webp: Safari's toBlob only learned webp recently */
        c.toBlob(function (b) {
          if (done) return;
          done = true; URL.revokeObjectURL(url);
          b ? resolve(b) : reject(new Error('canvas produced no image'));
        }, 'image/jpeg', 0.82);
      });
      v.addEventListener('error', function () { fail('browser cannot decode this video'); });
      setTimeout(function () { fail('timed out reading the video'); }, 20000);
    });
  }

  function safeName(n) {
    var dot = String(n || '').lastIndexOf('.');
    var base = slugify(dot > 0 ? n.slice(0, dot) : n) || 'upload';
    var ext = (dot > 0 ? n.slice(dot + 1) : '').toLowerCase().replace(/[^a-z0-9]/g, '') || 'bin';
    return 'gal-' + base.slice(0, 48) + '-' + Date.now().toString(36) + '.' + ext;
  }

  function renderTile(row) {
    if (!grid) return;
    var fig = document.createElement('figure');
    fig.className = 'g-item' + (row.v ? ' g-item--video' : '');
    fig.setAttribute('data-cat', row.c);
    var cap = row.p || row.c;
    fig.innerHTML = row.v
      ? '<button class="g-media g-vbtn" type="button" data-src="' + row.a + '" aria-label="' + cap + '">' +
        '<video muted playsinline preload="none"' + (row.po ? ' poster="' + row.po + '"' : '') +
        ' src="' + row.a + '#t=0.1" width="600" height="600" style="width:100%;height:100%;object-fit:cover;display:block"></video>' +
        '<span class="g-playicon" aria-hidden="true"><svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></span>' +
        '</button><figcaption class="g-cap">' + cap + '</figcaption>'
      : '<button class="g-media g-zoom" type="button" data-full="' + row.a + '" aria-label="' + cap + '">' +
        '<img src="' + row.a + '" alt="cycleWASH — ' + cap + '" loading="lazy" decoding="async" width="600" height="600">' +
        '</button><figcaption class="g-cap">' + cap + '</figcaption>';
    grid.insertBefore(fig, grid.firstChild);
    addPencils();
  }

  function addOne(file, cat, caption, report) {
    var isVid = /^video\//.test(file.type) || /\.(mp4|mov|m4v|webm)$/i.test(file.name);
    if (!isVid && !/^image\//.test(file.type)) {
      return Promise.reject(new Error('not an image or a video'));
    }
    if (file.size > (isVid ? MAX_VID : MAX_IMG)) {
      return Promise.reject(new Error('too big (max ' + (isVid ? '200' : '20') + ' MB)'));
    }

    var label = caption || cat.split(' ')[0].replace(/-/g, ' ');
    var name = safeName(file.name);
    var posterUrl = null;

    var first = isVid
      ? posterOf(file)
          .then(function (blob) {
            report('poster…');
            return uploadViaWorker(blob, name.replace(/\.[a-z0-9]+$/, '') + '-poster.jpg', false);
          })
          .then(function (u) { posterUrl = u; })
          .catch(function (e) {
            if (e.message === 'auth') throw e;
            /* a missing poster is a slower tile, not a failed upload */
            report('poster skipped (' + e.message + ')');
          })
      : Promise.resolve();

    return first
      .then(function () { report('uploading…'); return uploadViaWorker(file, name, isVid); })
      .then(function (url) {
        var row = {c: cat, a: url, p: label};
        if (isVid) { row.v = 1; if (posterUrl) row.po = posterUrl; }
        adds.push(row);
        cat.split(' ').forEach(function (t) { if (t && chips.indexOf(t) === -1) chips.push(t); });
        renderTile(row);
        refreshBar();
        report(posterUrl || !isVid ? 'ready' : 'ready, no poster', 'ok');
      });
  }

  var addBtn = document.createElement('button');
  addBtn.type = 'button';
  addBtn.className = 'cw-gadd';
  addBtn.innerHTML = PLUS + '<span>Add media</span>';
  document.body.appendChild(addBtn);

  var aov = document.createElement('div');
  aov.className = 'cw-gedit';
  aov.innerHTML =
    '<div class="cw-gedit__box">' +
      '<h3>Add photos or videos</h3>' +
      '<div class="cw-gedit__drop" id="cwGaDrop">Drop files here, or click to choose' +
        '<br><small>JPG / PNG / WebP up to 20 MB &middot; MP4 up to 40 MB</small></div>' +
      '<input type="file" id="cwGaFile" accept="image/*,video/mp4,video/quicktime" multiple hidden>' +
      '<select id="cwGaSel"></select>' +
      '<input id="cwGaNew" placeholder="…or type categories (space-separated for more than one)">' +
      '<input id="cwGaCap" placeholder="Caption for these files (optional)">' +
      '<ul class="cw-gedit__list" id="cwGaList"></ul>' +
      '<div class="cw-gedit__row">' +
        '<button class="cw-gedit__save" id="cwGaGo">Upload</button>' +
        '<button class="cw-gedit__cancel" id="cwGaClose">Close</button>' +
      '</div>' +
      '<p class="cw-gedit__note">Files go to Shopify as you press Upload; the gallery row itself is written when you press Apply. ' +
        'A brand-new category gets its own filter chip after the next page load.</p>' +
    '</div>';
  document.body.appendChild(aov);

  var queue = [];
  function pickFiles(files) {
    queue = [].slice.call(files || []);
    document.getElementById('cwGaList').innerHTML = queue.map(function (f, i) {
      return '<li><b>' + String(f.name).replace(/[<>&"]/g, '') + '</b>' +
        '<span id="cwGaS' + i + '">' + (f.size / 1048576).toFixed(1) + ' MB</span></li>';
    }).join('');
  }

  addBtn.addEventListener('click', function () {
    ensureAuth().then(function (ok) {
      if (!ok) return;
      var sel = document.getElementById('cwGaSel');
      sel.innerHTML = chips.map(function (c) { return '<option value="' + c + '">' + c + '</option>'; }).join('');
      document.getElementById('cwGaNew').value = '';
      document.getElementById('cwGaCap').value = '';
      pickFiles([]);
      aov.classList.add('open');
    });
  });
  document.getElementById('cwGaClose').addEventListener('click', function () { aov.classList.remove('open'); });
  aov.addEventListener('click', function (e) { if (e.target === aov) aov.classList.remove('open'); });

  var drop = document.getElementById('cwGaDrop');
  var fileInput = document.getElementById('cwGaFile');
  drop.addEventListener('click', function () { fileInput.click(); });
  fileInput.addEventListener('change', function () { pickFiles(fileInput.files); });
  ['dragenter', 'dragover'].forEach(function (ev) {
    drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('over'); });
  });
  ['dragleave', 'drop'].forEach(function (ev) {
    drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('over'); });
  });
  drop.addEventListener('drop', function (e) {
    if (e.dataTransfer && e.dataTransfer.files) pickFiles(e.dataTransfer.files);
  });

  document.getElementById('cwGaGo').addEventListener('click', function () {
    if (!queue.length) { alert('Choose at least one file first.'); return; }
    var typed = slugCats(document.getElementById('cwGaNew').value);
    var cat = typed || document.getElementById('cwGaSel').value;
    if (!cat) { alert('Pick a category, or type a new one.'); return; }
    var caption = document.getElementById('cwGaCap').value.trim();

    var go = this, label = go.textContent;
    go.disabled = true; go.textContent = 'Uploading…';
    var i = 0;
    function report(idx, msg, cls) {
      var s = document.getElementById('cwGaS' + idx);
      if (s) { s.textContent = msg; s.className = cls || ''; }
    }
    /* one at a time: a dozen parallel multipart PUTs to the bucket is how you
       get half of them cancelled on a hotel wifi */
    function next() {
      if (i >= queue.length) {
        go.disabled = false; go.textContent = label;
        fileInput.value = '';
        return;
      }
      var idx = i++;
      addOne(queue[idx], cat, caption, function (m, c) { report(idx, m, c); })
        .catch(function (e) {
          if (e.message === 'auth') {
            ensureAuth._ok = false;
            try { sessionStorage.removeItem(PW_KEY); } catch (err) {}
            report(idx, 'wrong admin password', 'bad');
          } else {
            report(idx, e.message, 'bad');
          }
        })
        .then(next);
    }
    next();
  });

  refreshBar();
})();
